module.exports = __webpack_public_path__ + "img/j1.7c0a10f0.png";